import React from 'react';
import { CheckboxList, TitledSection, CheckboxListItem } from 'components';
import { ACTIVE_STATUS } from 'shared/constants/obu';
import { useFilterContext } from '../../context';
import { useIntl } from 'react-intl';

export const ObuStatusFilter = () => {
  const { formatMessage } = useIntl();

  const options: CheckboxListItem[] = [
    {
      value: `${formatMessage({ id: 'locationStatusIsGotLess' }, { hours: 4 })}`,
      key: `${ACTIVE_STATUS.FROM_0_TO_4_HOURS}`,
    },
    {
      value: `${formatMessage({ id: 'locationStatusFromTo' }, { from: 4, to: 10 })}`,
      key: `${ACTIVE_STATUS.FROM_4_TO_10_HOURS}`,
    },
    {
      value: `${formatMessage({ id: 'locationStatusIsGotMore' }, { hours: 10 })}`,
      key: `${ACTIVE_STATUS.MORE_10}`,
    },
  ];

  const { onChangeLocationStatus, locationStatus } = useFilterContext();

  return (
    <TitledSection title={formatMessage({ id: 'locationStatus' })} paddingBottom={1} bordered={false}>
      <CheckboxList state={locationStatus} items={options} onChange={onChangeLocationStatus} />
    </TitledSection>
  );
};
